<nz-layout>
  <nz-header>
    <app-menu></app-menu>
  </nz-header>
  <nz-content>
    <router-outlet></router-outlet>
  </nz-content>
  <nz-footer *ngIf="false">Footer</nz-footer>
</nz-layout>